export enum DropdownRole {
  LocationExporter = "exporter",
  LocationImporter = "importer",
  Product = "product",
}
